import { Box, Divider, IconButton, InputAdornment } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Close, Search } from '@mui/icons-material';

import { TextInputRaw, TextInputRawProps } from '../../Inputs';

export type FlexTableSearchBarProps = {
  onChange: (value: string) => void;
  value: string;
  resetPageOnChange?: () => void;
  hideBorderBottom?: boolean;
} & Pick<TextInputRawProps, 'placeholder'>;

const useInputStyles = makeStyles()((theme) => ({
  root: {
    '& input[type="search"]::-webkit-search-cancel-button': {
      'display': 'none'
    },
  },
  notchedOutline: {
    border: 'none'
  },
  adornedStart: {
    paddingLeft: theme.spacing(3)
  },
  adornedEnd: {
    paddingRight: theme.spacing(1)
  }
}));

const useStyles = makeStyles()((theme) => ({
  searchIcon: {
    color: theme.palette.text.secondary
  },
  startAdornment: {
    marginRight: theme.spacing(2)
  }
}));

export const FlexTableSearchBar: React.VFC<FlexTableSearchBarProps> = (props) => {
  const { classes: inputClasses } = useInputStyles();
  const { classes } = useStyles();

  const onSearchValueChange = (value: string) => {
    props.onChange(value);
    props.resetPageOnChange?.();
  };

  const startAdornment = (
    <InputAdornment position="start" className={classes.startAdornment}>
      <Search className={classes.searchIcon} />
    </InputAdornment>
  );

  const endAdornment = (
    <InputAdornment position="end">
      <IconButton onClick={() => onSearchValueChange('')}>
        <Close />
      </IconButton>
    </InputAdornment>
  );


  return (
    <>

      <Box display="flex" flexDirection="row" width="100%">
        <Box py={1} style={{ width: '100%' }}>
          <TextInputRaw
            type="search"
            name="search"
            value={props.value}
            setValue={onSearchValueChange}
            onChange={(e) => onSearchValueChange(e.target.value)}
            endAdornment={props.value ? endAdornment : null}
            startAdornment={startAdornment}
            fullWidth
            inputClasses={inputClasses}
            placeholder={props.placeholder}
            data-testid="flex-table-search-bar"
          />
        </Box>
      </Box>
      {!props.hideBorderBottom && (
        <Box mt={1}>
          <Divider />
        </Box>
      )}
    </>

  );
};
